<template>
  <form-row>
    <label for="zoneId" class="ordered-counter">
      {{ $t('product-detail.form.center-zone.label') }}
    </label>

    <select id="zoneId" name="zoneId" @change="setZone($event.target.value)">
      <option value=""/>
      <option v-for="zone in zonesToShow"
              :key="zone.id"
              :value="zone.id"
              :selected="selectedZone && zone.id === selectedZone.id">
        {{ `${zone.code} - ${zone.title}` }}
      </option>
    </select>

    <ul v-if="validation.$error" class="ui-state-error" role="alert" aria-atomic="true" aria-live="polite">
      <li v-if="!validation.required">{{ $t('product-detail.form.center-zone.validation.required') }}</li>
    </ul>
  </form-row>
</template>

<script>
import FormRow from '../components/FormRow'
import { Zone } from '../../types/filter-entity/zone'

export default {
  components: {
    FormRow
  },
  props: {
    selectedZone: {
      type: Zone,
      default: null
    },
    zones: {
      type: Array,
      required: true
    },
    validation: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    zonesToShow: function () {
      return this.zones.filter(zone => zone.nrOfProductConfigurations > 0).sort((a, b) => a.code - b.code)
    }
  },
  methods: {
    setZone: function (zoneId) {
      this.$emit('input', this.zonesToShow.find(zone => zone.id === zoneId))
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/forms/order-item/CenterZone.vue